export const NAVBAR_BLOCK_s2 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#0F0F0F"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "✦ Magic",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "About Us",
      "linkUrl": "/about",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Contact Us",
      "linkUrl": "/contact",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Signup",
      "linkUrl": "/signup",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Get Started",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#ffffff",
        "border-width": "1px",
        "border-radius": "9999px",
        "padding": "14px 30px 14px 30px",
        "margin": "0px 0px 0px 120px",
        "border-color": "#4f4f4f",
        "background-color": "#1f1f1f"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#ffffff",
    "border-color": "#ffffff"
  },
  "metaDataId": 1746274576179,
  "afterIndex": 0,
  "blockId": 1746274576179,
  "linksStyleProps": {
    "color": "#8A8A8E",
    "padding": "14px 0px 14px 0px"
  }
}